// extracted by mini-css-extract-plugin
export var header = "styles-module--header--gLiYm";
export var headerContent = "styles-module--headerContent--8yPRe";
export var image = "styles-module--image--Xl4WS";
export var linkFacebook = "styles-module--linkFacebook--avmP8";
export var linkInstagram = "styles-module--linkInstagram--CKuhs";
export var links = "styles-module--links--qfXAg";
export var title = "styles-module--title--TnnD3";